export enum MovableItemRotationAmount {
	None,
	TurnLeft,
	TurnRight,
	UTurn,
}

export enum MovableItemOrientation {
	Up,
	Right,
	Down,
	Left,
}

export function getMovableItemOrientation(name: string): MovableItemOrientation {
	switch (name) {
		case 'Up':
			return MovableItemOrientation.Up;
		case 'Right':
			return MovableItemOrientation.Right;
		case 'Down':
			return MovableItemOrientation.Down;
		case 'Left':
			return MovableItemOrientation.Left;
	}

	throw new Error('Invalid MovableItemOrientation name.');
}

export function turnMovableItem(turns: number, rotation: MovableItemRotationAmount): number {
	switch (rotation) {
		case MovableItemRotationAmount.None:
			return turns;

		case MovableItemRotationAmount.TurnLeft:
			return turns - 1;

		case MovableItemRotationAmount.TurnRight:
			return turns + 1;

		case MovableItemRotationAmount.UTurn:
			return turns + 2;
	}
}

export function rotateMovableItemOrientation(
	orientation: MovableItemOrientation,
	rotation: MovableItemRotationAmount,
): MovableItemOrientation {
	switch (rotation) {
		case MovableItemRotationAmount.None:
			return orientation;

		case MovableItemRotationAmount.TurnLeft:
			switch (orientation) {
				case MovableItemOrientation.Up:
					return MovableItemOrientation.Left;
				case MovableItemOrientation.Right:
					return MovableItemOrientation.Up;
				case MovableItemOrientation.Down:
					return MovableItemOrientation.Right;
				case MovableItemOrientation.Left:
					return MovableItemOrientation.Down;
			}

		case MovableItemRotationAmount.TurnRight:
			switch (orientation) {
				case MovableItemOrientation.Up:
					return MovableItemOrientation.Right;
				case MovableItemOrientation.Right:
					return MovableItemOrientation.Down;
				case MovableItemOrientation.Down:
					return MovableItemOrientation.Left;
				case MovableItemOrientation.Left:
					return MovableItemOrientation.Up;
			}

		case MovableItemRotationAmount.UTurn:
			switch (orientation) {
				case MovableItemOrientation.Up:
					return MovableItemOrientation.Down;
				case MovableItemOrientation.Right:
					return MovableItemOrientation.Left;
				case MovableItemOrientation.Down:
					return MovableItemOrientation.Up;
				case MovableItemOrientation.Left:
					return MovableItemOrientation.Right;
			}
	}

	throw new Error('Invalid rotation amount.');
}

export type MovableItemLocation = {
	row: number;
	col: number;
	orientation: MovableItemOrientation;
	turns: number;
};

export function getTurnsFromOrientation(orientation: MovableItemOrientation): number {
	switch (orientation) {
		case MovableItemOrientation.Up:
			return 0;
		case MovableItemOrientation.Right:
			return 1;
		case MovableItemOrientation.Down:
			return 2;
		case MovableItemOrientation.Left:
			return 3;
	}

	throw new Error('Invalid orientation.');
}

export default class MovableItem {
	protected _id: string;
	get id(): string {
		return this._id;
	}

	constructor(id: string) {
		this._id = id;
	}

	public clone(): MovableItem {
		throw new Error('Subclasses must override.');
	}
}
